import { DocumentStatus, Error } from "./data";

export class UserCompanyDetails {
    success: true|false;
    error: Error;
    results: string;
    data: UserCompanyDetailsData;
}

export class UserCompanyDetailsData {
    ref: number;
    name: string;
    address: string;
    regNo: string;
    tradeName: string;
    email: string;
    phone: string;
    whatsapp: string;
    object: string;
    purpose: string;
    financialYear: string;
    affiliate: string;
    license: UserCompanyDetailsLicense;
    regulator: string;
    status: DocumentStatus;
    created: string;
    lastModified: string;

    constructor() {
        this.status = new DocumentStatus();
        this.license = new UserCompanyDetailsLicense();
    }
}

export class UserCompanyDetailsLicense {
    body: string;
    number: string;
}